import React from 'react';
import { useIntl } from 'react-intl';
import { formatMessage } from '@99designs/frontend-components/i18n';
import TrackScrollToPageElement from '../../../../shared/components/Analytics/TrackScrollToPageElement';
import Box from '../../../../shared/components/Box';
import Heading from '../../../../shared/components/Heading';
import localizedLowercase from '../../../../shared/lib/localizedLowercase';
import { ContestType } from '../ContestOverviewData';
import { WinnersFAQs } from '../FAQs';
import MultipleWinnersCarousel from './MultipleWinnersCarousel';
import OpenContestSection from './OpenContestSection';

interface Props {
    contest: ContestType;
}

export default function WinnersSection({ contest }: Props) {
    const { locale } = useIntl();
    return (
        <>
            <TrackScrollToPageElement pageName="Contest Overview" pageElement="Winners Section">
                <div className="row" data-testid="winners-section">
                    <div className="column small-12 medium-8 medium-offset-2 normal-4 normal-offset-2 large-4 large-offset-2">
                        <Box paddingBottom={['space14', 'space14', 'space14', 'space14']}>
                            <Heading type="h2" variations={['h1', 'no-margin']}>
                                {contest.isCompleted
                                    ? getTitle(contest.winningEntries.length)
                                    : formatMessage(__('{clientName} will soon select a winner!'), {
                                          clientName: contest.owner.displayName,
                                      })}
                            </Heading>
                        </Box>
                    </div>
                </div>
            </TrackScrollToPageElement>
            {contest.isCompleted ? (
                <MultipleWinnersCarousel
                    winningEntries={contest.winningEntries}
                    Faqs={
                        <WinnersFAQs
                            categoryDeliverable={localizedLowercase(locale, contest.category.title)}
                        />
                    }
                />
            ) : (
                <OpenContestSection
                    categoryTitle={localizedLowercase(locale, contest.category.title)}
                />
            )}
        </>
    );
}

const getTitle = (winnerCount: number): string => {
    if (winnerCount > 1) {
        return formatMessage(__('And then… they selected {winnerCount} winners!'), {
            winnerCount: winnerCount,
        });
    } else {
        return __('And then… they selected a winner!');
    }
};
